



































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import ChangePassword from '@/components/shared/ChangePassword.vue'
import Cart from '@/components/panier/Cart.vue'
import LangSwitcher  from '@/components/shared/LangSwitcher.vue'
import Printer  from '@/components/shared/Printer.vue'


@Component({
  name:"App",
  components:{ChangePassword,Cart,LangSwitcher,Printer}
})
export default class App extends Vue {
  private clipped = true
  private drawer = true
  private miniVariant = false
  private right = true
  private title = 'ASP.NET Core Vue Starter'
  private openUserMenu = false  

  onResize(){
    //@ts-ignore
    this.$store.myActions.UI_SET_CONTENT_HEIGHT(window.innerHeight - this.$refs.appBar.$el.clientHeight - 20)            
  }

  created() {                        
  }

  mounted(){
    this.onResize()
  }

  goHome(){
    if(this.$route.name != 'Home') this.$router.push({name:'Home'})
  }

  get cssProps  () {
    return {
      //@ts-ignore
      '--secondary-color': this.$vuetify.theme.themes.light.secondary,
      //@ts-ignore
      '--primary-color': this.$vuetify.theme.themes.light.primary
    }
  }

  get panier() {
    return this.$store.myGetters.panier    
  }  

  get isAuthenticated(){
    return this.$store.myGetters.isAuthenticated
  }

  get isVisiteur(){
    return this.$store.myGetters.isVisiteur
  }
  

  get canOrder(){
    return this.$store.myGetters.canOrder
  }

  get canRoomService(){
    return this.$store.myGetters.canRoomService
  }

  get canReception(){
    return this.$store.myGetters.canReception
  }

  get canAdmin(){
    return this.$store.myGetters.canAdmin
  }  

  get userName(){
    return this.isAuthenticated ?this.$store.myGetters.user.libelle : "Visiteur"
  }

  get showSnacks() {
     return this.$store.myGetters.snackMessages.length > 0
  }

  set showSnacks(newValue) {
    this.$store.myActions.UI_CLOSE_SNACKBAR()
  }
    
  get snackMessages(){
    return this.$store.myGetters.snackMessages
  }

  get rightDrawerEnable() {
    return this.$store.myGetters.rightDrawerEnable
  }  

  set rightDrawerEnable(newValue:boolean) {
    this.$store.myActions.UI_SET_RIGHT_DRAWER_ENABLE(newValue)
  }
  
  get rightDrawerOpen() {
    return this.$store.myGetters.rightDrawerOpen
  }

  set rightDrawerOpen(newValue:boolean) {
    this.$store.myActions.UI_SET_RIGHT_DRAWER_OPEN(newValue)
  }

  get routemeta() {
      return this.$route.matched.reduce((a,item) => { return {...a,...item.meta}},{})
  }

  get rightDrawerIcon(){
    //@ts-ignore
    return this.routemeta.rightDrawerIcon || 'mdi-magnify'
  }

  get printMode()
  {
    return this.$store.myGetters.printMode
  }
  
  @Watch('$route')
  onRouteUpdate() {    
    this.rightDrawerEnable = false
  }


  logout() {           
    this.$store.myActions.AUTH_LOGOUT_REQUEST()
  }

  changePassword() { (this.$refs.changePassword as ChangePassword).edit() }

}
